module.exports = __webpack_public_path__ + "line-awesome.452a5b42cb4819f09d35.woff2";


//////////////////
// WEBPACK FOOTER
// J:/Dev/Workspaces/NovaSingular/JulianaGimenez/angular/src/assets/metronic/src/vendors/line-awesome/fonts/line-awesome.woff2?v=1.1.
// module id = ../../../../../src/assets/metronic/src/vendors/line-awesome/fonts/line-awesome.woff2?v=1.1.
// module chunks = styles